import { isAfter, isSameDay } from "date-fns";
import { z } from "zod";

import i18n from "@/i18n";

const congressDetailsSchema = z
  .object({
    congId: z.coerce.number().int().positive({
      message: i18n.t("validation.positiveInteger"),
    }),
    name: z.string().min(1, { message: i18n.t("validation.nameRequired") }),
    date: z.object({
      from: z.date({
        required_error: i18n.t("validation.startDateRequired"),
      }),
      to: z.date({
        required_error: i18n.t("validation.endDateRequired"),
      }),
    }),
    coverImage: z.object({
      id: z.string().min(1, { message: i18n.t("validation.imageRequired") }),
      url: z.string(),
    }),
    textColor: z.string().regex(/^#([0-9A-Fa-f]{3}){1,2}$/, {
      message: i18n.t("validation.invalidHex"),
    }),
    backgroundColor: z.string().regex(/^#([0-9A-Fa-f]{3}){1,2}$/, {
      message: i18n.t("validation.invalidHex"),
    }),
    status: z.boolean(),
    isHidden: z.boolean(),
    source: z.string().url().min(1, { message: i18n.t("validation.sourceUrlRequired") }),
    timezone: z.string().min(1, { message: i18n.t("validation.timezoneRequired") }),
  })
  .refine(
    (data) => {
      const fromDate = data.date.from;
      const toDate = data.date.to;
      // Allow same day or later (compare at day level, ignore time)
      return isAfter(toDate, fromDate) || isSameDay(toDate, fromDate);
    },
    {
      message: i18n.t("validation.endDateBeforeStart"),
      path: ["date", "to"],
    },
  );

type CongressDetailsFormData = z.infer<typeof congressDetailsSchema>;

export { congressDetailsSchema };
export type { CongressDetailsFormData };
